import React from 'react';
import svgIcons from './';

interface IconProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    name: string;
    width?: string;
    height?: string;
    color?: string;
    className?:string;
}

const CustomIcon: React.FC<IconProps> = ({ name, width = '1rem', height = '1rem', className = "", ...props}) => {

    const SvgIcon = svgIcons[name]; // Dynamically fetch the SVG component

    if (!SvgIcon) {
        return <span>{name}</span>; // Handle missing icon case
    }

    return <span {...props} className={"custom-icon " + className}><SvgIcon className={'d-inline align-middle'} width={width} height={height}  /></span>;
};

export default CustomIcon;
